(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("DevTools", [], factory);
	else if(typeof exports === 'object')
		exports["DevTools"] = factory();
	else
		root["DevTools"] = factory();
})(window, function() {
return 